<script>
  import { Link } from 'svelte-navigator';
  // import DetectRTC from "detectrtc";
  import Button from '../components/Button.svelte';
  import Modal from '../components/Modal.svelte';
  import NavBar from '../components/NavBar.svelte';

  import Fer from '../Fer.js';

  let videoInput;
  let fer;
  let frameCount = 0;
  let modalVisible = false;
  let cameraStarted = false;
  let initializingCamera = false;

  const showModal = () => {
    modalVisible = true;
  };

  let hasPermission = false;
  // DetectRTC.load(function() {
  //   hasPermission = DetectRTC.isWebsiteHasWebcamPermissions;
  // });
  // TODO use this to check if the user has a webcam
  // DetectRTC.hasWebcam

  const startCamera = () => {
    if (!initializingCamera) {
      const cam = new Camera(videoInput, {
        facingMode: 'user',
        width: 1280,
        height: 720,
        onFrame: async () => {
          await fer.getExpression(videoInput, 1280, 720);
          frameCount += 1;
          if (frameCount > 3) {
            cameraStarted = true;
            initializingCamera = false;
          }
        },
      });
      fer = Fer.getInstance();
      fer.setupTf().then(() => {
        cam.start();
      });
      initializingCamera = true;
    }
  };
</script>

<section class="home">
  <NavBar />
  <div class="home__hero ">
    <div class="home__hero--img   slide-up" />
    <div class="home__hero--text  slide-up">
      <p>Flex your facial muscles by completing tasks in the garden</p>
    </div>
    <div class="home__hero--btn  slide-up">
      {#if hasPermission}
        <Link to="/games">
          <Button buttonSize="btn--xlarge" buttonStyle="btn--primary--solid">
            PLAY
          </Button>
        </Link>
      {:else}
        <Button
          on:click={showModal}
          buttonSize="btn--xlarge"
          buttonStyle="btn--primary--solid"
        >
          PLAY
        </Button>
      {/if}

      <Link to="/about">
        <Button buttonSize="btn--xlarge" buttonStyle="btn--primary--outline">
          ABOUT
        </Button>
      </Link>
    </div>
  </div>
  {#if modalVisible}
    <Modal>
      <div slot="content">
        <video
          class="camera"
          style="transform: scaleX(-1);"
          bind:this={videoInput}
        >
          <track kind="captions" srclang="en" label="english_captions" />
        </video>
      </div>
      <div class="home__hero--btn" slot="buttons">
        {#if !cameraStarted}
          <Button
            on:click={startCamera}
            buttonSize="btn--xlarge"
            buttonStyle="btn--primary--solid"
            style="display: none;"
          >
            START CAMERA
          </Button>
        {/if}

        {#if initializingCamera}
          <Button buttonSize="btn--xlarge" buttonStyle="btn--primary--solid"
            >INITIALIZING ...</Button
          >
        {/if}
        {#if cameraStarted}
          <Link to="/games">
            <Button
              buttonSize="btn--xlarge"
              buttonStyle="btn--primary--outline"
            >
              PLAY
            </Button>
          </Link>
        {/if}
        
        <div class="home__modalfooter">
          <p>
            This game will be using your webcam and machine learning to analyze your
            facial expressions. Everything is processed locally and no webcam data
            will be stored anywhere.
          </p>
        </div>
      </div>
    </Modal>
  {/if}
  <div class="home__footer">
    <!-- <p class="fadeIn">
      This game will be using your webcam and machine learning to analyze your
      facial expressions. Everything is processed locally and no webcam data
      will be stored anywhere.
    </p> -->
  </div>
</section>
